const Macy = require('macy');

export default class macygrid {
   constructor(){
      const par = this;
      
      if($('.artists-grid--wrap').length > 0) {
         this.adjustGrid();
      }
      // Call adjustGrid on load and resize
      $(window).on('resize', function() { par.adjustGrid() });
   }
   
   adjustGrid() {
      if(window.innerWidth <= 787) {
         if(window.macyInstance) {
            window.macyInstance.remove();
         }
         return;
      }
      const container = $('.artists-grid--wrap');
      const totalWidth = container.width();
      const totalHeight = container.innerHeight();
      const numItems = container.children().length;
      
      // Calculate the number of columns and rows trying to fit as square as possible
      let cols = Math.round(Math.sqrt(numItems * totalWidth / totalHeight));
      if (cols === 0) cols = 1;  // Prevent division by zero
      let rows = Math.ceil(numItems / cols);
      
      console.log(cols,rows);
      
      // Calculate adjusted box sizes
      const boxWidth = totalWidth  / cols;
      const boxHeight = totalHeight / rows;
      
      // Apply the calculated dimensions to the boxes
      container.children().css({
         'width': boxWidth + 'px',
         'height': boxHeight + 'px'
      });
      
      // console.log(boxWidth,boxHeight);
      
      // Reinitialize Macy if it exists or create a new instance
      if (window.macyInstance) {
         window.macyInstance.reInit({
            columns: cols,
            margin: 0, //remToPx(1)
         });
      } else {
         window.macyInstance = Macy({
            container: '.artists-grid--wrap',
            trueOrder: true,
            waitForImages: false,
            margin: 0, //remToPx(1),
            columns: cols,
            breakAt: {},
            useContainerForBreakpoints: true,
         });
         
         window.macyInstance.runOnImageLoad(function () {
            window.macyInstance.recalculate(true);
         }, true);
      }
   }
}
